import React, { useState } from "react";
import { Image, StyleSheet, View, StatusBar } from "react-native";
import { connect } from "react-redux";
import { setUserLoginData } from "../../actions/user";
import { STYLES } from "../../assets/styles";
import { lightenColor } from "../../common";
import AccountVerification from "../../components/AccountVerification";
import CustomIcon from "../../components/CustomIcon";
import Loading from "../../components/Loading";
import SignIN from "../../components/SignIN";

function SignIn({ navigation, loginUser }) {
  const [loading, setLoading] = useState(false);
  const [verifyUser, setVerifyUser] = useState(null);

  const handleNavigation = ({ route, params = {} }) => {
    navigation.navigate(route, params);
  };

  return (
    <>
      {verifyUser ? (
        <AccountVerification
          userId={verifyUser.user_id}
          onSuccess={() => {
            loginUser(verifyUser);
          }}
          onClose={() => {
            setVerifyUser(null);
          }}
        />
      ) : (
        <View style={{ flex: 1 }}>
          <Image
            source={require("./../../assets/images/image5.jpg")}
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
            }}
          />
          <View
            style={{
              flex: 1,
              backgroundColor: lightenColor(STYLES.colors.black, "50"),
            }}
          >
            <View
              style={{
                padding: 10,
                paddingTop: StatusBar.currentHeight,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <CustomIcon
                type="AntDesign"
                name="left"
                onPress={() => navigation.goBack()}
                style={{
                  fontSize: STYLES.fontSizes.xlarge,
                  color: STYLES.colors.white,
                }}
              />
            </View>
            <View style={styles.container}>
              <SignIN
                transparent
                onLoadingChange={setLoading}
                onForgotPress={() => handleNavigation({ route: "forgot" })}
                onCreateAccountPress={() =>
                  handleNavigation({ route: "signup" })
                }
              />
            </View>
            {loading ? <Loading spinner /> : null}
          </View>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  loginUser: (data) => dispatch(setUserLoginData(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
